export default __webpack_public_path__ + "static/media/12-32-16 2.1a01ed68.jpg";